import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { LoggerAssociation } from './interfaces';
import { CrmActivityLoggerAssociationComponent } from './association.component';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CrmActivityLoggerObjectAssociationField } from './association-field.component';
import { CompanyTableCustomizationService } from '../../../../shared-services/table-customization/company-table-customization.service';

@Component({
  selector: 'crm-activity-logger-company-association',
  templateUrl: './company-association.component.html',
  imports: [CommonModule, CrmActivityLoggerAssociationComponent],
  standalone: true,
})
export class CrmActivityLoggerCompanyAssociationComponent extends CrmActivityLoggerObjectAssociationField {
  @Input({ required: true }) set associations(value: LoggerAssociation[]) {
    this.setAssociations(value);
  }
  @Input() fixedId: string | null = null;
  @Input({ transform: coerceBooleanProperty }) mobile: boolean | null = null;
  @Input() placeholder = '';

  @Output() associationsChange = new EventEmitter<LoggerAssociation[]>();

  protected readonly customizationService = inject(CompanyTableCustomizationService);
  protected readonly crmObjectType = 'Company';

  handleAdd(association: LoggerAssociation): void {
    const associations = this.associationsList();
    if (!associations.find((a) => a.crmObjectId === association.crmObjectId)) {
      const newAssociations = [...associations, association];
      this.associationsList.set(newAssociations);
      this.associationsChange.emit(newAssociations);
    }
  }

  handleRemove(association: LoggerAssociation): void {
    const associations = this.associationsList().filter((a) => a.crmObjectId !== association.crmObjectId);
    this.associationsList.set(associations);
    this.associationsChange.emit(associations);
  }

  handleSearchTermChange(searchTerm?: unknown): void {
    this.updateSearchTerm(searchTerm);
  }
}
